import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Access } from 'src/app/interfaces/api/access';
import { ApiService } from 'src/app/services/core/api.service';
import { environment } from 'src/environments/environment';

type QueryParams = Record<string, string | number | boolean | Date | Array<string | number | boolean | Date> | object>;

@Injectable({
  providedIn: 'root'
})
export class AccessService {
  collection = "Access";
  collectionPath = "access";
  roles: any[] = [];
  apiUrl = environment.API_URL;

  constructor(
    private apiService: ApiService,
    public http: HttpClient,
  ) { }

  //---GET---//

  getAccesses(query: any = {}): Observable<any> {
    return this.apiService.getCollection(this.collectionPath, "", query);
  }

  searchAndCountAccesses(search: string, query: QueryParams = {}): Observable<{ results: Access[], total: number }> {
    return this.apiService.getCollection(this.collectionPath, 'searchAndCount', { q: search, ...query });
  }

  //---POST---//

  addAccess(access: any): Observable<any> {
    return this.apiService.postCollectionData(this.collectionPath, '', access);
  }

  //---PUT---//

  updateAccess(access: any): Observable<any> {
    return this.apiService.updateCollectionItem(this.collectionPath, access);
  }

  //---DELETE---//

  removeAccess(id: string): Observable<any> {
    return this.apiService.deleteCollectionItem(this.collectionPath, id);
  }
}
